import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SiteConfiguration } from './site-configuration';
import { Configuration } from 'src/app/common/enumerations/enumerations';
import { NgModel } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SiteConfigurationService {

  constructor(private http: HttpClient) { }

  getValue(id: Configuration): Observable<SiteConfiguration> {
    return this.http.get<SiteConfiguration>(environment.urls.baseApiUrl + '/SiteConfiguration/' + id);
  }
  getAll(): Observable<SiteConfiguration[]> {
    return this.http.get<SiteConfiguration[]>(environment.urls.baseApiUrl + '/SiteConfiguration');
  }
  update(value: SiteConfiguration) {
    return this.http.put<SiteConfiguration>(environment.urls.baseApiUrl + '/SiteConfiguration', value);
  }
  updateAll(values: { id: number, value: string; }[]) {
    return this.http.put<SiteConfiguration[]>(environment.urls.baseApiUrl + '/SiteConfiguration/UpdateAll', values);
  }

  emailTest() {
    return this.http.patch(environment.urls.baseApiUrl + '/SiteConfiguration/EmailTest', null);
  }
}
